export default __webpack_public_path__ + "00d99c1197ff01e8fbfa02d52eeb6376.png";